import HouseSvg from '@assets/images/svg/house.svg';
import React from 'react';

export interface HouseIconProps {
    size?: number;
    color?: string;
}

export const HouseIcon = React.memo<HouseIconProps>(function HouseIcon({ size = 24, color = '#1A1A1A' }) {
    return <HouseSvg width={size} height={size} color={color} />;
});

export default HouseIcon;
